module.exports = __webpack_public_path__ + "img/_MG_8711.78a3cd90.jpg";